export interface IOrderStatusCounts {
  open: number;
  partlyFinished: number;
  finished: number;
  canceled: number;
}

export interface ITableResults<T> {
  results: T[];
  info: {
    page: number;
    results: number;
    totalResults: number;
    exportTableName: string;
  };
  statusCounts?: IOrderStatusCounts;
}
